<template>
  <div class="card">
    <div class="card-image">
      <router-link :to="{ path: `/projects/${project.id}` }">
        <figure class="image is-4by3">
          <img :src="project.attributes.cover_image" alt="Placeholder image" />
        </figure>
      </router-link>
    </div>
    <div class="card-content">
      <div class="content">
        <router-link :to="{ path: `/projects/${project.id}` }"
          ><span class="is-size-6 ellipsis has-text-dark-primary">{{
            project.attributes.title
          }}</span></router-link
        >
        <span
          v-if="project.attributes.character || project.attributes.universe"
          class="ellipsis"
        >
          <span class="is-size-7" v-if="project.attributes.character">{{
            project.attributes.character
          }}</span>
          <span
            class="is-size-7"
            v-if="project.attributes.character && project.attributes.universe"
          >
            from
          </span>
          <span class="is-size-7" v-if="project.attributes.universe">{{
            project.attributes.universe
          }}</span>
        </span>
        <span v-else class="ellipsis is-size-7 has-text-gray">ㅤ</span>

        <b-tooltip
          append-to-body
          type="is-gray"
          :label="`Last update ${dateFromNow(project.attributes.updated_at)}`"
        >
          <small class="is-italic has-text-gray">
            <b-icon size="is-small" icon="update"></b-icon>
            <time datetime="2016-1-1">{{
              formatDate(project.attributes.created_at)
            }}</time>
          </small>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { dateMixin } from '@/mixins/dateMixin'

export default {
  props: ['project'],
  mixins: [dateMixin]
}
</script>
